import PropTypes from 'prop-types';

const CPUIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.1333 30.8667V17.2H30.8V30.8667H17.1333ZM21.1333 26.8667H26.8V21.2H21.1333V26.8667ZM16 48V42.6667H9.33333C8.26667 42.6667 7.33333 42.2667 6.53333 41.4667C5.73333 40.6667 5.33333 39.7333 5.33333 38.6667V32H0V28H5.33333V19.7333H0V15.7333H5.33333V9.06667C5.33333 8 5.73333 7.06667 6.53333 6.26667C7.33333 5.46667 8.26667 5.06667 9.33333 5.06667H16V0H20V5.06667H28.2667V0H32.2667V5.06667H38.9333C40 5.06667 40.9333 5.46667 41.7333 6.26667C42.5333 7.06667 42.9333 8 42.9333 9.06667V15.7333H48V19.7333H42.9333V28H48V32H42.9333V38.6667C42.9333 39.7333 42.5333 40.6667 41.7333 41.4667C40.9333 42.2667 40 42.6667 38.9333 42.6667H32.2667V48H28.2667V42.6667H20V48H16ZM38.9333 38.6667V9.06667H9.33333V38.6667H38.9333Z"
        fill={fill}
      />
    </svg>
  </div>
);

CPUIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CPUIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CPUIcon;
